import {
  accountDetailApi,
  accountEditApi,
  accountListApi,
  accountRegisterApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { userActions } from "./actions";

export function* userSaga() {
  yield takeEveryFsa(userActions.fetchUsers.started, function* (action) {
    yield* makeAsyncApiCall(action, userActions.fetchUsers, accountListApi);
  });

  yield takeEveryFsa(userActions.getUserDetails.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      userActions.getUserDetails,
      accountDetailApi,
    );
  });

  yield takeEveryFsa(userActions.registerNewUser.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      userActions.registerNewUser,
      accountRegisterApi,
    );
  });

  yield takeEveryFsa(userActions.updateUser.started, function* (action) {
    yield* makeAsyncApiCall(action, userActions.updateUser, accountEditApi);
  });
}
